<div class="web-view" fxLayout="column">

    <div class="web" fxHide.xs fxHide.sm fxHide.lt-md fxFlex.md>
        <div class="navbar-div">
            <app-web-navbar></app-web-navbar>
        </div>
    </div>

    <div class="mobile" fxHide.lg fxHide.md fxHide.lt fxFlex.lt-md fxShow.xs fxHide.gt-lg>

        <div class="mobile-navbar">
            <app-sidebar></app-sidebar>
        </div>

        <div class="navbar-div">
            <app-web-navbar></app-web-navbar>
        </div>

    </div>

    <div class="main-div" fxLayout="column wrap">


     <ng-container *ngIf="featuredGuests.length">
        <div class="red header"><span>FEATURED ARTISTS APPEARING DURING SPOTLIGHT RED CARPETS</span></div>
        <div class="carousel-item-owl"
            *ngFor="let item of featuredGuests;  let even = even; let odd = odd;; let i = index;"
            [ngClass]="{ 'black': odd, 'red': even }">
            <h1 class="font-weight-light white cus-header" (click)="navigateToSpotlight()">{{item.date | date:'longDate'}} - Spotlight</h1>

            <owl-carousel-o [options]="customOptions" style="width: 90%;">
                <ng-container *ngFor="let slide of item?.featuredGuests">
                    <ng-template carouselSlide [id]="slide.id">
                        <img [src]="slide.image" [alt]="slide.image" [title]="slide.movieName"
                            class="carousel-image-container">
                        <div class="mt-2" class="carousel-movie-text">
                            <span class="white movieName mt-2">
                                {{slide?.name}}
                            </span>
                            <span class="white movieUrl mt-3"><a [href]="slide.movieUrl" target="_blank"
                                    class="white movieUrl mt-3">{{slide?.movieName}}</a></span>
                        </div>
                    </ng-template>
                </ng-container>

            </owl-carousel-o>
        </div>
    </ng-container>
    <ng-container *ngIf="!featuredGuests.length">
        <div class="red header"><span>No Spotlight FEATURED ARTISTS Available. </span></div>
    </ng-container>
        <div class="carousel-item-owl "
            [ngClass]="cinejoyHostsClass">
            <h1 class="font-weight-light white">CINEJOY HOSTS
            </h1>

            <owl-carousel-o [options]="customOptions" style="width: 90%;">
                <ng-container *ngFor="let slide of cinejoyHosts">
                    <ng-template carouselSlide [id]="slide.id">
                        <img [src]="slide.image" [alt]="slide.image" [title]="slide.name"
                            class="carousel-image-container">
                        <div class="mt-2" class="carousel-movie-text">
                            <span class="white movieName mt-2">
                                {{slide?.name}}
                            </span>
                        </div>
                    </ng-template>
                </ng-container>

            </owl-carousel-o>
        </div>
    </div>


    <div class="footer-div" fxHide.xs fxHide.sm fxHide.lt-md fxFlex.md>
        <app-cinejoy-footer></app-cinejoy-footer>
    </div>

    <div class="footer-div" fxHide.lg fxHide.md fxHide.lt fxFlex.lt-md fxShow.xs fxHide.gt-lg>
        <app-cinejoy-mobile-footer></app-cinejoy-mobile-footer>
    </div>

</div>